import { RawCarInfoModel, CarInfoResponse } from "."

export function mapCarInfoResponse(response: RawCarInfoModel): CarInfoResponse {
    return {
        ...response.carInfo,
        // TODO
    }
}
